import { ConsumableOverviewThemeModeConfig } from './types';

const dark: ConsumableOverviewThemeModeConfig = {
  consumableOverview: {
    normalButtonBGColor: '#505251',
    normalButtonBorderColor: '2px solid #267DAC',
    profileHeaderBG: '#505251',
    differenceContainerBG: '#7C7C7C',
    differenceContainerFontColor: 'white',
    backgroundColor: '#505251',
    backgroundGradient: 'linear-gradient(to bottom, #eeeeeeee, #ffffffff)',
    cardBackgroundGradient: 'linear-gradient(to bottom, #1a1a1a88, #00000044)',
    hoverBackgroundGradient: 'linear-gradient(to bottom,rgb(34, 34, 34), #00000099)',
    borderColor: '#b0b6bd',
    boxShadow: '0 8px 12px 0 #4d4d4d, 0 8px 12px #1a1a1a, 8px 10px 12px 0 #1a1a1a',
    textColor: '#1f2328',
    textColorLight: '#ffffff',
    labelBGColor: '#50525a',
    backgroundColorLight: '#e9ecef',
    backgroundColorDark: '#dde1e6',
    hoverBackgroundColor: '#c7dbf0',
    hoverBckgroundCellColor: '#b9d0e8',
    linkColor: '#0b57b0',
    highlightCellBG: '#ffccdd99',
  },
};

export default dark;
